import { Trans } from "react-i18next";
import { SFIcons } from "@sf-core";
import { Navigate } from "react-router-dom";

import { LPScreens, LPRoutes } from "@sf-launchpad";

const baseRoutes = [
  {
    path: "/",
    component: <LPScreens.LPHome />,
    exact: null,
    label: <Trans i18nKey="routes.home" />,
    showInSideMenu: true,
    icon: <SFIcons.SFDashboardIcon />,
  },
];

const catchAllRoutes = {
  path: "*",
  component: <Navigate to="/" replace />, // Redirect to home using Navigate
};

export const ROUTES = [...baseRoutes, ...LPRoutes, catchAllRoutes];
